// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
// straight from java now we here
// https://github.com/Driftt/conversation-api/blob/master/ConversationService/src/main/java/com/driftt/conversation/api/conversation/ConversationStatus.java

import Enum from 'enum'
import { Set } from 'immutable'

export const ConversationStatusEnum = new Enum(['OPEN', 'PENDING', 'CLOSED', 'ARCHIVED'])
export const ActiveConversationStatusEnum = new Enum(['OPEN', 'PENDING', 'CLOSED'])
export const ActiveConversationStatuses = Set(['OPEN', 'PENDING', 'CLOSED'])



// WEBPACK FOOTER //
// ./src/scripts/constants/ConversationStatusConstants.js